<template>
    <div class="ls-radios">
        <label v-if="label" class="ls-label ls-margin--top" for="radio">{{ label }}</label>
        <div class="ls-radios--wrapper ls-input__wrapper">
            <label v-for="option in options" :key="option.value" class="ls-radios--container"
                >{{ option.label }}
                <input
                    v-model="localValue"
                    type="radio"
                    name="radio"
                    :value="option.value"
                    test-id="ls-radio"
                    @blur="$emit('blur')"
                />
                <span :class="classes" class="ls-radios--checkmark"></span>
            </label>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import { lsPropTypeHelpers, lsTrackingService } from 'ls-vue-common';

export default {
    name: 'LsRadios',
    props: {
        value: VueTypes.any.isRequired,
        trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
        options: VueTypes.arrayOf(
            VueTypes.shape({
                label: VueTypes.string.isRequired,
                value: VueTypes.any.isRequired,
            })
        ).isRequired,
        label: VueTypes.string,
        classes: VueTypes.object,
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(value) {
                lsTrackingService.track({
                    event: 'click',
                    target: this.trackId,
                    data: { value },
                });
                this.$emit('input', value);
            },
        },
    },
};
</script>

<style lang="scss">
.ls-radios {
    @include min-screen(breakpoint(md)) {
        .ls-radios--wrapper {
            display: flex;
            flex-flow: row wrap;
            > label {
                flex: 50%;
                max-width: 200px;
            }
        }
    }

    /* Customize the label (the container) */
    .ls-radios--container {
        display: block;
        position: relative;
        padding-left: 25px;
        margin-bottom: 15px;
        cursor: pointer;
        font-size: 14px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default radio button */
    .ls-radios--container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom radio button */
    .ls-radios--checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 16px;
        width: 16px;
        background-color: #fff;
        border-radius: 50%;
        border: 1px solid #abb8b2;

        &.ls-invalid {
            border-color: palette(red, mid);
        }
    }

    /* Create the indicator (the dot/circle - hidden when not checked) */
    .ls-radios--checkmark:after {
        content: '';
        position: absolute;
        display: none;
    }

    /* Show the indicator (dot/circle) when checked */
    .ls-radios--container input:checked ~ .ls-radios--checkmark:after {
        display: block;
    }

    /* Style the indicator (dot/circle) */
    .ls-radios--container .ls-radios--checkmark:after {
        top: 2px;
        left: 2px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #0ab463;
    }
}

.themed-app {
    .ls-radios {
        .ls-radios--checkmark {
            background-color: $theme-color-white;
            border-color: $theme-color-gray-dark;

            &.ls-invalid {
                border-color: $theme-color-danger;
            }
        }
        .ls-radios--container .ls-radios--checkmark:after {
            background: $theme-color-primary;
        }
    }
}
</style>
